export default "__VITE_ASSET__CqozLyPC__"